<form [formGroup]="residenceInfoFormGroup" (ngSubmit)="onSubmit(residenceInfoFormGroup)" >
    <p class="heading">Proof of Residence</p>
    <p class="secondary-text">You have to upload a soft-copy of the selected address proof in the next step. Please
        ensure that the address is
        clearly visible. Field verification will be done at this address.</p>

    <p class="form-field-heading">Proof Type</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <mat-select placeholder="Select a residence proof" formControlName="proofType"
                        (selectionChange)="onProofTypeChanged(residenceInfoFormGroup)">
                <mat-option *ngFor="let proofType of proofTypes" [value]="proofType.value">
                    {{ proofType.displayName }}
                </mat-option>
            </mat-select>
            <mat-error>{{ getErrorMessage(residenceInfoFormGroup.controls.proofType) }}</mat-error>
        </mat-form-field>
    </div>

    <div *ngIf="residenceInfoFormGroup.controls.proofType.value !== AadhaarProofType && residenceInfoFormGroup.controls.proofType.value ">
        <p class="form-field-heading">Proof Number</p>
        <div class="row">
            <mat-form-field class="col-xs-12">
                <input type="text" [placeholder]=getPlaceholderForProofNumber(residenceInfoFormGroup) matInput
                       [formControlName]="FormControlNameProofNumber">
                <mat-error>{{ getErrorMessage(residenceInfoFormGroup.controls.proofNumber) }}</mat-error>
            </mat-form-field>
        </div>
    </div>
    <div *ngIf="residenceInfoFormGroup.controls.proofType.value === AadhaarProofType" class="aadhaar-info">
        <ul>
            <li>Masked e-Aadhaar can be used as a Proof of Address only if your Aadhaar is linked to your mobile number.
                To verify if your mobile
                number is linked to your Aadhaar, please visit
                <a href="https://myaadhaar.uidai.gov.in/verify-email-mobile" target="_blank" rel="noopener">
                    https://myaadhaar.uidai.gov.in/verify-email-mobile</a>.
                If it is not linked, please do this by visiting your nearest Aadhaar enrolment center.
            </li>
            <li>In the upcoming pages we will give you quick guidelines on how to download a masked copy of your Aadhaar
                from
                UIDAI website. Click on "NEXT" button to proceed to upload Aadhaar as your address proof.
            </li>
        </ul>
    </div>
    <div *ngIf="applicationFlowType === 0">
        <p class="small-heading">Is your mobile linked with Aadhaar</p>
        <p class="secondary-text">This information would help us support you to electronically sign your loan documents
            post loan approval</p>
        <div class="row">
            <div class="radio-toolbar col-xs-12">
                <div *ngFor="let answer of aadharLinkAnswers">
                    <input type="radio" id="{{answer.id}}" formControlName="aadhaarLinkedWithMobile"
                           [value]="answer.value" required>
                    <label for="{{answer.id}}">{{answer.display}}</label>
                </div>
            </div>
            <div class="col-xs-12">
        <span class="text-color-red unselected-error-text" *ngIf="isFormSubmitted && residenceInfoFormGroup.controls.aadhaarLinkedWithMobile.invalid">
          {{getErrorMessage(residenceInfoFormGroup.controls.aadhaarLinkedWithMobile)}}
        </span>
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 20px">
        <div class="col-xs-6">
            <button mat-stroked-button class="button-back primary" type="button" [routerLink]="backLink">
                <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
            </button>
        </div>
        <div class="col-xs-6">
            <div class="pull-right">
                <app-forward-button class="button-forward" [isLoading]="loaderStatus.isLoading"
                        (click)="analyticsTracker.trackButtonClick('Residence Information', 'Next')">
                    NEXT
                </app-forward-button>
            </div>
        </div>
    </div>
</form>
